import { ApiService } from "../ApiService";
import { ItemGroup } from "../../Types/Admin/AdminProductGroupType";
import { ResultsDTO } from "Types/ResultsDTO";

export const itemGroupApi = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllItemGroups: builder.query<ItemGroup[], string>({
      query: (plant) => ({
        url: "/ItemGroups/getAll",
        method: "GET",
        params: { plant },
      }),
      transformResponse: (res: ResultsDTO<ItemGroup[]>) => res.results ?? [],
      providesTags: ["ItemGroup"],
    }),
  }),
});

export const { useGetAllItemGroupsQuery } = itemGroupApi;
